import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./bootstrap.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { printProjectInfo } from "./utils/projectInfo";

printProjectInfo();

// Always start at the top after a hard refresh.
// Some browsers restore the previous scroll position by default.
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
window.scrollTo(0, 0);
window.addEventListener("load", () => window.scrollTo(0, 0));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
